import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { properties } from '../../../../environments/properties';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { Observable } from 'rxjs';
import { ImagePreloadService } from 'src/app/shared/services/image-preload.service';

@Component({
  selector: 'app-cancel-freshpass-discounts-selection',
  templateUrl: './cancel-freshpass-discounts-selection.component.html',
  styleUrls: ['./cancel-freshpass-discounts-selection.component.scss']
})
export class CancelFreshpassDiscountsSelectionComponent implements OnInit {

  @Input() userSubscriptionDetails: any;
  @Input() retentionPlanDiscounts: any;
  @Output() cancelPlan: EventEmitter<Object> = new EventEmitter();
  @Output() getDiscountOptionSelected: EventEmitter<Object> = new EventEmitter();
  @Input() cancelBenefitsTilesJSON: any;
  @Input() isServiceError!: Observable<any>;
  @Input() errorMessage: any;
  @Output() onErrorChange = new EventEmitter<boolean>();
  cancelBenefitsHeader: string = "";
  public domain: string;
  properties = properties;
  public showBenefitsContainer: boolean = false;
  tileArray: Array<object>;
  currentErrorValue: boolean = false;
  public showLoader: boolean = true;
  public benefits =[];
  private imageUrls = [
    "ocsp-web-ui/dist/assets/images/discounts_tag.svg",
    "ocsp-web-ui/dist/assets/images/freshpass_discounts_img.svg",
    "ocsp-web-ui/dist/assets/images/error-close-icon.svg"
];

  constructor(public subscriptionService: SubscriptionService, private imagePreloadService: ImagePreloadService,) { 
    this.domain = this.subscriptionService.getApplicationDomainURL();
  }

  ngOnInit(): void {
    this.isServiceError.subscribe((val) => (this.currentErrorValue = val));
    this.initFreshpassBenefitTiles();
    this.initPreLoadImages(this.imageUrls, false);
  }

  goToBenefitsInfo() {
    this.showLoader = true;
    this.onErrorChange.emit(false);
    this.showBenefitsContainer = true;
    this.initPreLoadImages(this.benefits.map(tile => tile.tileImage), true);
  }

  onDiscountOptionClick() {
    this.onErrorChange.emit(false);
    this.getDiscountOptionSelected.emit();
  }
  goToCancelPlan() {
    this.cancelPlan.emit();
  }

  initFreshpassBenefitTiles(): void {
    if (this.cancelBenefitsTilesJSON) {
      this.benefits = Object.values(this.cancelBenefitsTilesJSON.benefits)
        .filter((tile: any) => tile?.fileReference && tile?.rteTitle)
        .map((tile: any) => {
          let tileImageURL = this.getTileImage(tile);
          return {
            ...tile,
            tileImage: tileImageURL
          };
        });
    }
  }

  getTileImage(tile): string {
    let tileImageURL = tile?.fileReference || tile?.fpImage
    const svgType = '.svg'
    if (tileImageURL?.includes(svgType)) {
      tileImageURL = this.domain + tileImageURL;
    }
    return tileImageURL
  }

  initPreLoadImages(images: string[], loadBenefitsTiles: boolean = false): void {
    this.imagePreloadService.preloadImages(images)
      .then(() => {
        if (loadBenefitsTiles) {
          this.tileArray = this.benefits;
          this.cancelBenefitsHeader = this.cancelBenefitsTilesJSON?.header;
        }
        this.showLoader = false;
      })
      .catch(() => {
        this.showLoader = false;
      })
  }
}
